<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M19.7451 10.0052C21.4183 10.8589 21.4183 13.1417 19.7451 13.9951L8.50368 19.7284C6.91856 20.5365 5 19.4443 5 17.7333V6.26682C5 4.55582 6.91856 3.46332 8.50368 4.27173L19.7451 10.0052Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
